module.exports = __webpack_public_path__ + "10_mole.0d727ac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer2/10_mole.png
// module id = jm8a
// module chunks = 0